@if (visibleAssignment.length > 0) {
	@if (isV2()) {
		<div class="assignments-v2">
			<p class="assignments-v2-heading">{{ "ASSIGNMENT__ASSIGNMENTS" | transloco }}</p>
			@for (assignment of visibleAssignment; track assignment) {
				<button type="button" class="assignment-card" (click)="option(assignment)">
					<div class="assignment-card-top">
						<p class="assignment-card-title">{{ assignment.assignment.name }}</p>
						<span class="assignment-card-status">
							<span class="assignment-card-status-dot" aria-hidden="true"></span>
							{{ statusLabel(assignment) }}
						</span>
					</div>
					<div class="assignment-card-meta">
						@if (assigneeLabel(assignment); as assignee) {
							<span>
								<span class="material-symbols-outlined" aria-hidden="true">group</span>
								{{ assignee }}
							</span>
						}
						@if (deadlineLabel(assignment); as deadline) {
							<span>
								<span class="material-symbols-outlined" aria-hidden="true">calendar_today</span>
								{{ deadline }}
							</span>
						}
						@if (priorityLabel(assignment); as priority) {
							<span [class.assignment-card-priority]="isHighPriority(assignment)">
								<span class="material-symbols-outlined" aria-hidden="true">flag</span>
								{{ priority }}
							</span>
						}
					</div>
					@if (evidenceLabel(assignment); as evidence) {
						<p class="assignment-card-evidence">{{ evidence }}</p>
					}
				</button>
			}
		</div>
	} @else {
		<ion-list lines="full">
			<ion-list-header lines="full">{{ "ASSIGNMENT__ASSIGNMENTS" | transloco }}</ion-list-header>
			<ion-item (click)="option(assignment)" lines="full" *ngFor="let assignment of visibleAssignment">
				<ion-label>
					{{ assignment.assignment.name }}
					<p>{{ assignment.assignment.target.name }}</p>
				</ion-label>
			</ion-item>
		</ion-list>
	}
}
